import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const addItemPrice = catchAsync(async (body) => {
  const { data } = await axiosInstance.post('/api/resource/Item Price', body);
  return data;
});
export const updateItemPrice = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Item Price/${id}`,
    body
  );
  return data;
});

export const getItemPrice = catchAsync(async ({key="",value=""}) => {
  let baseUrl =  '/api/resource/Item Price?fields=["currency","buying","name","item_name","price_list","price_list_rate","valid_from","valid_upto"]&limit_page_length=0'
  if(value){
      baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
   }
  const { data } = await axiosInstance.get(
    baseUrl
  );
  return data;
});
export const deleteItemPrice = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Item Price/${record}`
  );
  return data;
});
export const getItemPriceDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/api/resource/Item Price/${id}`);
  return data;
});
